module.exports = __webpack_public_path__ + "6f0036809f5d72ac73808651febaa48b.svg"